import React from 'react';
import './Successful.css';

interface SuccessfulOrderMessageProps {
  className?: string;
}

const SuccessfulOrderMessage: React.FC<SuccessfulOrderMessageProps> = ({ className }) => {
  return (
    <div className={`successful-order-message ${className ? className : ''}`}>
      Order placed! You will receive an email confirmation.
    </div>
  );
};

export default SuccessfulOrderMessage;